import get from 'lodash/fp/get';
import { createSelector } from 'reselect';

const selectForgotPassword = (state) => get('forgotMyPassword', state);

const forgotMyPasswordIsProcessing = createSelector(
  selectForgotPassword,
  (forgotMyPassword) => forgotMyPassword.forgotIsProcessing
);
export default forgotMyPasswordIsProcessing;
